export const SUBSCRIPTION_STATUS = {
  PENDING: 'pending',
  TRIALING: 'trialing',
  PAUSED: 'paused',
  CANCELLED: 'canceled',
  ACTIVE: 'active',
  PAST_DUE: 'past-due',
  INCOMPLETE: 'incomplete',
}
